import { observable } from "mobx";
import required from "@libs/required";

class SearchBar {
	service;
	@observable zipcode;

	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this.zipcode = (staticContext.app.location || {}).zipcode;
	}

	get textFieldStore() {
		const { textFieldStore } = this.rootStore.stores;
		return textFieldStore;
	}

	updateService(service) {
		this.service = service;
	}

	updateZipcode(val) {
		this.zipcode = val;
	}

	redirect(groupId = "search-bar") {
		if (!this.service) return;
		if (this.service.midtail)
			window.location.href = `/search?midtail=${this.service.key}&zipcode=${
				this.zipcode || ""
			}`;
		else
			window.location.href = `/search?service=${this.service.key}&zipcode=${
				this.zipcode || ""
			}`;
	}
}

export default SearchBar;
